export var CONSENT_MANAGER = {
    USER_CONSENT_LEVEL_CHANGED: 'CONSENT_MANAGER.USER_CONSENT_LEVEL_CHANGED',
    CONSENT_MANAGER_BLOCKED: 'CONSENT_MANAGER.CONSENT_MANAGER_BLOCKED'
};
//# sourceMappingURL=consent-manager.js.map